// Режимы шага: недельный (по умолчанию) липнет к понедельнику и воскресенью, дневной — точные дни.
import { addDays, mondayOf, sundayOf, type ISODate } from '@core/dates';
import type { DragKind } from './geometry';

export const snapStart = (s: ISODate, day: boolean): ISODate => (day ? s : mondayOf(s));
export const snapEnd = (s: ISODate, day: boolean): ISODate => (day ? s : sundayOf(s));

/** Край после сдвига мыши на days дней; задача не короче дня, в недельном режиме — недели. */
export function resizeTarget(t: { start_date: ISODate; end_date: ISODate }, kind: Exclude<DragKind, 'move'>, days: number, day: boolean): { start_date: ISODate; end_date: ISODate } {
  if (kind === 'resize-end') {
    const end = snapEnd(addDays(t.end_date, days), day);
    const min = day ? t.start_date : sundayOf(t.start_date);
    return { start_date: t.start_date, end_date: end < min ? min : end };
  }
  const start = snapStart(addDays(t.start_date, days), day);
  const max = day ? t.end_date : mondayOf(t.end_date);
  return { start_date: start > max ? max : start, end_date: t.end_date };
}

/** Стрелки: шаг 7 (или 0) — к понедельнику, шаг 1 — по дням. */
export const keyStart = (start: ISODate, days: number): ISODate => (Math.abs(days) === 7 || days === 0 ? mondayOf(addDays(start, days)) : addDays(start, days));
export const keyEnd = (end: ISODate, grow: number): ISODate => (Math.abs(grow) === 7 ? sundayOf(addDays(end, grow)) : addDays(end, grow));
